import { render, staticRenderFns } from "./create-quiz.vue?vue&type=template&id=23d82d09&scoped=true"
import script from "./create-quiz.vue?vue&type=script&lang=js"
export * from "./create-quiz.vue?vue&type=script&lang=js"
import style0 from "./create-quiz.vue?vue&type=style&index=0&id=23d82d09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d82d09",
  null
  
)

export default component.exports